import { clearProposalId, clearTypeModal, } from '../../../../features/gms-state-and-modal/modal-slice';
import { useDispatch, useSelector } from 'react-redux';
import { selectedProposalExtensionPreparedBy, selectedProposalExtensionSECName, setClearProposalExtension, } from '../../../../features/gms-state-and-modal/state-slice';
import { useExtensionActions } from '../../../../hooks/actions/use-extension-actions';

export default function ProposalExtensionActionModal() {

    const dispatch = useDispatch();
    const SECName = useSelector(selectedProposalExtensionSECName);
    const preparedBy = useSelector(selectedProposalExtensionPreparedBy);
    const {
        isLoadingApproveExtension,
        isLoadingDeclinedExtension,
        handleActionExtension,
    } = useExtensionActions();

    const isSubmitting = isLoadingApproveExtension || isLoadingDeclinedExtension;

    const handleBack = () => {
        if (isSubmitting) return;
        dispatch(clearProposalId());
        dispatch(clearTypeModal());
        dispatch(setClearProposalExtension());
    };

    return (
        <>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-[2px]">
                <div className="relative w-full max-w-[420px] overflow-hidden rounded-xl border border-gray-200 bg-white shadow-xl">
                    {/* HEADER */}
                    <div className="border-b border-gray-100 px-5 py-4">
                        <div className="flex items-start gap-3">
                            <div className="min-w-0">
                                <h2 className="text-sm font-semibold text-gray-900">
                                    Proposal Extension Request
                                </h2>
                                <p className="mt-0.5 text-[11px] text-gray-500">
                                    Review the request before taking action.
                                </p>
                            </div>
                        </div>
                    </div>
                    {/* CONTENT */}
                    <div className="px-5 py-5">
                        <p className="text-xs leading-5 text-gray-600">
                            An extension request has been submitted by{' '}
                            <span className="font-semibold text-gray-800">
                                {preparedBy}
                            </span>{' '}
                            for client{' '}
                            <span className="font-semibold text-gray-800">
                                {SECName}
                            </span>
                            .
                        </p>
                    </div>
                    {/* ACTIONS */}
                    <div className="flex items-center justify-end gap-2 border-t border-gray-100 bg-gray-50/70 px-5 py-3">
                        <button
                            type="button"
                            onClick={handleBack}
                            disabled={isSubmitting}
                            className="rounded-lg border border-gray-200 bg-white px-3.5 py-2 text-xs font-semibold text-gray-600 transition hover:border-gray-300 hover:bg-gray-50 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            Back
                        </button>
                        <button
                            type="button"
                            onClick={() => handleActionExtension('reject')}
                            disabled={isSubmitting}
                            className="flex min-w-[72px] items-center justify-center gap-1.5 rounded-lg border border-red-200 bg-white px-3.5 py-2 text-xs font-semibold text-red-600 transition hover:bg-red-50 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {isLoadingDeclinedExtension ? (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-3.5 w-3.5 animate-spin" >
                                        <circle cx="12" cy="12" r="9" className="opacity-25" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a9 9 0 0 1 9 9" />
                                    </svg>
                                    <span>Rejecting...</span>
                                </>
                            ) : ( 'Reject' )}
                        </button>
                        <button
                            type="button"
                            onClick={() => handleActionExtension('accept')}
                            disabled={isSubmitting}
                            className="flex min-w-[72px] items-center justify-center gap-1.5 rounded-lg bg-green-600 px-3.5 py-2 text-xs font-semibold text-white shadow-sm transition hover:bg-green-700 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {isLoadingApproveExtension ? (
                                <>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-3.5 w-3.5 animate-spin" >
                                        <circle cx="12" cy="12" r="9" className="opacity-25" />
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 3a9 9 0 0 1 9 9" />
                                    </svg>
                                    <span>Approving...</span>
                                </>
                            ) : ( 'Accept' )}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
}